import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import ApiService from 'utils/ApiCalls';

export interface OptionType {
  value: number;
  label: string;
}

export const useModuleOptions = (industry: any) => {
  const [moduleOptionsState, setModuleOptionsState] = useState<OptionType[]>(
    []
  );

  const { lang } = useSelector((state: RootState) => ({
    lang: state.global.lang
  }));

  const industryArray = Array.isArray(industry)
    ? industry
    : industry
    ? [industry]
    : [];

  const fetchModules = async (): Promise<OptionType[]> => {
    try {
      if (!industryArray.length) {
        setModuleOptionsState([]);
        return [];
      }

      const ids = industryArray.map((item: any) => item.value ?? item);

      const responses = await Promise.all(
        ids.map((id: number) =>
          ApiService.getModulesByIndustries({
            lang,
            ind_id: id
          })
        )
      );

      const merged = responses.flatMap(
        (response) => response?.data?.data ?? []
      );

      const unique = Array.from(
        new Map(merged.map((module: any) => [module.mod_id, module])).values()
      );

      const modules: OptionType[] = unique
        .filter((module: any) => module?.mod_id != null)
        .map((module: any) => ({
          value: module.mod_id,
          label: module.module
        }));

      setModuleOptionsState(modules);

      return modules;
    } catch (error) {
      console.error('Failed to fetch modules:', error);
      setModuleOptionsState([]);
      return [];
    }
  };

  useEffect(() => {
    fetchModules();
  }, [JSON.stringify(industryArray), lang]);

  return {
    moduleOptionsState,
    fetchModules
  };
};
